<template>
  <div :class="{'is-visible': show}" class="popup-overlay">
    <div class="popup-container popup-container--2cols popup-terms">
      <div class="row">
        <div class="coll-full">
          <h2>Thank you for subscribing to our newsletter</h2>

          <div class="popup-body text-center">
            To complete the process, please click on the authentication link that has just been sent to your email
          </div>

          <a @click.prevent="close" href="#" title="close" class="popup-container__close">Close</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      required: true,
      type: Boolean,
    }
  },

  watch: {
    show(show) {
      if (show) {
        $('body').addClass('overflow-hidden');
      } else {
        $('body').removeClass('overflow-hidden');
      }
    },
  },

  methods: {
    close() {
      this.$emit('close');
    }
  },
};
</script>

<style scoped>
  .popup-body {
    color: #555;
  }

  .row {
    width: 94%;
    margin: 0 auto;
  }
</style>
